/**
 * Dispatched from PDP Configure & Buy (delivery ZIP link) to open the global
 * header Change my location modal without a shared React parent.
 */
export const OPEN_CHANGE_MY_LOCATION_EVENT = 'pmi:open-change-my-location'

export function dispatchOpenChangeMyLocation(): void {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(OPEN_CHANGE_MY_LOCATION_EVENT))
}
